import { render, staticRenderFns } from "./InventoryDispatch.vue?vue&type=template&id=78f925b3&scoped=true"
import script from "./InventoryDispatch.vue?vue&type=script&lang=js"
export * from "./InventoryDispatch.vue?vue&type=script&lang=js"
import style0 from "./InventoryDispatch.vue?vue&type=style&index=0&id=78f925b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f925b3",
  null
  
)

export default component.exports